import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useLocation , useNavigate } from "react-router-dom";
function Faq() {
  const [open, setOpen] = useState(0);
const location = useLocation();
const navigate = useNavigate();
const goToSection = (id) => {
  // If we're on the Sales page,
  // navigate to Home and tell it where to scroll.
  if (isSalesPage) {
    navigate("/", {
      state: {
        scrollTo: id,
      },
    });

    return;
  }

  // If we're on some other page (not Home),
  // also navigate Home first.
  if (location.pathname !== "/") {
    navigate("/", {
      state: {
        scrollTo: id,
      },
    });

    return;
  }

  // Already on Home → just scroll.
  const el = document.getElementById(id);

  if (el) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};
const isSalesPage = location.pathname === "/agents/sales";
  const homeFaqs  = [
    {
      question: "What is Craft Your Agent?",
      answer:
        "Craft Your Agent is a no-code platform that lets you create AI agents trained on your business knowledge. Clone voices, customize conversations, and deploy agents in minutes."    },
    {
      question: "Is my voice and business data secure?",
      answer:
       "Yes. Your voice recordings and business knowledge are encrypted and protected with enterprise-grade security, giving you full control over your data."    },
    {
      question: "Which languages does the platform support?",
      answer:
       "Our AI agents support 50+ languages, allowing you to communicate naturally with customers and teams around the world."    },
    {
      question: "Can I clone my own voice?",
      answer:
        "Yes. Simply upload a voice recording with your consent, and our AI creates a highly realistic digital version of your voice."    },
    {
      question:
        "Can I create AI agents for different business teams?",
      answer:
        "Yes. You can build multiple AI agents, each tailored to a specific role within your organization. Create dedicated agents for Sales, HR, Customer Support, Customer Success, Employee Training, or any custom workflow. Every agent can have its own voice, knowledge base, personality, and conversation flow, ensuring it performs exactly the way your team needs."    },
  ];
const salesFaqs = [
  {
    question: "What is Sales AI?",
    answer:
      "Sales AI is an AI sales agent that guides reps live during sales calls—with real-time discovery questions, solution mapping, and objection handling—then scores every demo afterward.",
  },
  {
    question: "Can clients see the Sales AI overlay?",
    answer:
      "No, unless your rep chooses to share it. By default, the Sales AI overlay is visible only to the sales rep, providing real-time guidance during the conversation.",
  },
  {
    question: "Does Sales AI record calls?",
    answer:
      "Yes. Sales AI records and transcribes meetings with built-in consent controls, while securely capturing conversation insights, action items, and coaching data. Your data always remains under your control.",
  },
  {
    question: "How long does setup take?",
    answer:
      "Just a few minutes. Sales AI works seamlessly with your existing meeting platforms, so your team can start using real-time AI guidance without changing their workflow.",
  },
  {
    question:
      "How is Sales AI different from a notetaker or conversation intelligence tool?",
    answer:
      "Notetakers capture conversations. Conversation intelligence tools analyze them after they're over. Sales AI actively supports your reps during live customer conversations with personalized guidance, instant objection handling, and AI-powered recommendations—helping them win deals while the opportunity is still alive.",
  },
];
const faqs = isSalesPage ? salesFaqs : homeFaqs;
  return (
    <section id="faq"
      className="
		py-14
		md:py-20
		lg:py-28

		px-4
		sm:px-6
	"
      style={{ zoom: "0.79" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <div
          className="
		grid
		grid-cols-1
md:grid-cols-[380px_1fr]
xl:grid-cols-[490px_1fr]

		gap-8
		lg:gap-12
	"
        >
          {/* LEFT SIDE */}

          <div
            className="
    flex
    flex-col

    items-center
    lg:items-start

    text-center
    lg:text-left
  "
          >
            <span
              className="
								inline-block
mx-auto
lg:mx-0
								bg-[#FFE4DE]
								text-[#F06A50]
								font-semibold
                                font-prompt
								text-sm
md:text-base
lg:text-[18px]
								px-3
								py-2
								rounded-md
							"
            >
              FAQ
            </span>

            <h2
              className="
    mt-6
    font-prompt
    font-bold
    text-[32px]
    sm:text-[40px]
    lg:text-[48px]
    leading-[1.05]
    text-[#46453D]

    text-center
    lg:text-left
  "
            >
              Frequently
              <br />
              Asked Questions
            </h2>

            {/* Bottom Card */}

            <div
              className="
mt-8
lg:mt-16
xl:mt-24
	bg-white
	rounded-[18px]
	p-5
	shadow-[0_4px_20px_rgba(0,0,0,0.05)]
"
            >
              <h3
                className="
    font-jakarta
    font-bold
    text-[20px]
    lg:text-[24px]
    text-[#46453D]

    text-center
    lg:text-left
  "
              >
                Still Have Questions?
              </h3>

              <p
                className="
    mt-4
    text-[#666]
    text-[14px]
    sm:text-[15px]
    leading-[1.8]
    font-jakarta

    text-center
    lg:text-left
  "
              >
          {
  isSalesPage
    ? "Can't find the answer you're looking for? Our team is happy to walk you through exactly how the AI Sales Agent works, what it takes to get started, and how it fits into your existing sales process - no pressure, just answers."
    : "Can't find the answer you're looking for? Our team is happy to walk you through exactly how Craft Your Agent works, what it takes to get started, and how it fits into your existing sales process - no pressure, just answers."
}
             </p>

       <button
  onClick={() => goToSection("live-demo")}
  className="
    mt-6
    w-full
    h-[58px]
    bg-[#F06A50]
    text-white
    font-semibold
    rounded-lg
    hover:opacity-90
    transition
  "
>
  Book a Demo →
</button>
            </div>
          </div>

          {/* RIGHT SIDE */}

          <div className="flex flex-col gap-4 lg:gap-5">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="
	bg-white
	border
	border-[#E5E2DE]
	rounded-[16px]
	overflow-hidden
	transition-all
	duration-300
	hover:shadow-[0_10px_30px_rgba(0,0,0,0.12)]
	hover:-translate-y-1
"
              >
                <button
                  onClick={() => setOpen(open === index ? -1 : index)}
                  className="
										w-full
										flex
										items-center
										justify-between
										px-4
sm:px-6
lg:px-8

py-5
lg:py-7
										text-left
									"
                >
                  <h3
                    className="
											font-prompt
											font-bold
											text-[16px]
sm:text-[18px]
lg:text-[22px]

leading-snug
pr-4
											text-[#1F2A44]
										"
                  >
                    {faq.question}
                  </h3>

                  {open === index ? (
                    <Minus
                      size={20}
                      className="sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-[#1F2A44]"
                    />
                  ) : (
                    <Plus
                      size={20}
                      className="sm:w-6 sm:h-6 lg:w-7 lg:h-7 text-[#1F2A44]"
                    />
                  )}
                </button>

                {open === index && (
                  <div
                    className="
											px-4
sm:px-6
lg:px-8

pb-5
lg:pb-7
										"
                  >
                    <p
                      className="
												text-[#666]
												text-[18px]
                        font-jakarta 
												leading-[1.8]
												max-w-[850px]
											"
                    >
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Faq;
